import { defineStore } from 'pinia'
import { ref } from 'vue'
import { documentStorage } from '../services/knowledgeApi'
import TurndownService from 'turndown'

const turndown = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced'
})

export const useDocumentStore = defineStore('knowledgeDocument', () => {
  const openDocuments = ref(new Map()) // documentId -> document data
  const isLoading = ref(false)

  async function fetchDocument(documentId) {
    if (openDocuments.value.has(documentId)) {
      return openDocuments.value.get(documentId)
    }
    isLoading.value = true
    try {
      const doc = await documentStorage.getById(documentId)
      if (doc) {
        openDocuments.value.set(documentId, doc)
        // 触发响应式
        openDocuments.value = new Map(openDocuments.value)
      }
      return doc
    } finally {
      isLoading.value = false
    }
  }

  async function fetchDocumentByNodeId(nodeId) {
    const doc = await documentStorage.getByNodeId(nodeId)
    if (doc) {
      openDocuments.value.set(doc.document_id, doc)
      openDocuments.value = new Map(openDocuments.value)
    }
    return doc
  }

  async function saveDocument(documentId, contentHtml) {
    // 双格式存储: HTML + Markdown
    const contentMd = turndown.turndown(contentHtml || '')
    const updated = await documentStorage.update(documentId, {
      content_html: contentHtml,
      content_md: contentMd
    })
    openDocuments.value.set(documentId, updated)
    openDocuments.value = new Map(openDocuments.value)
    return updated
  }

  async function updateTitle(documentId, title) {
    const updated = await documentStorage.update(documentId, { title })
    openDocuments.value.set(documentId, updated)
    openDocuments.value = new Map(openDocuments.value)
    return updated
  }

  function closeDocument(documentId) {
    openDocuments.value.delete(documentId)
    openDocuments.value = new Map(openDocuments.value)
  }

  function getDocument(documentId) {
    return openDocuments.value.get(documentId) || null
  }

  return {
    openDocuments,
    isLoading,
    fetchDocument,
    fetchDocumentByNodeId,
    saveDocument,
    updateTitle,
    closeDocument,
    getDocument
  }
})
